"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var CalendarIcon_1 = require("../../Icons/CalendarIcon");
var Input_1 = require("../../Input");
var DateInputField = /** @class */ (function (_super) {
    __extends(DateInputField, _super);
    function DateInputField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focus = function () {
            _this.input.focus();
        };
        return _this;
    }
    DateInputField.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, onClick = _a.onClick, disabled = _a.disabled, className = _a.className, other = __rest(_a, ["children", "onClick", "disabled", "className"]);
        var inputClassName = classNames(className, 'ee_date-input-field__control');
        var componentClassName = classNames('ee_date-input-field', {
            'ee_date-input-field--disabled': disabled
        });
        var iconDescription = 'Kalender öffnen';
        return (React.createElement("div", { className: componentClassName },
            React.createElement(Input_1.Input, __assign({ ref: function (input) { return (_this.input = input); }, className: inputClassName, disabled: disabled, onClick: onClick, autoCorrect: "off", spellCheck: false }, other)),
            React.createElement("span", { className: "ee_date-input-field__calendar-icon-wrapper", onClick: onClick, onKeyDown: onClick, role: "button", "aria-label": iconDescription, tabIndex: 0 },
                React.createElement(CalendarIcon_1.default, { width: "1em", height: "1em", title: iconDescription, className: "ee_date-input-field__calendar-icon" }))));
    };
    DateInputField.propTypes = Input_1.Input.propTypes;
    DateInputField.defaultProps = Input_1.Input.defaultProps;
    return DateInputField;
}(React.Component));
exports.DateInputField = DateInputField;
//# sourceMappingURL=date_input_field.js.map